<template>
    <div class="home-footer-container">
        <div class="slogan1-container">
            博雅美育浸润·五馆合一
        </div>
        <div class="slogan2-container">
            课题引领&nbsp;&nbsp;&nbsp;专家赋能&nbsp;&nbsp;&nbsp;五馆合一&nbsp;&nbsp;&nbsp;营在规划
        </div>
        <div class="slogan3-container">
            “阅读之美 · 文化之美 · 创美之美 · 实践之美 · 行走之美”
        </div>
        <div class="slogan4-container">
            五美融合 落地大美育浸润理念
        </div>
        <div class="slogan5-container">
            <div class="slogan6-container">
                从线上美育资源到线下沉浸式体验 一站式美育解决方案
            </div>
            <div class="slogan6-container">
                © 2026 博雅美育浸润版权所有 | Copyright ©2026-博雅美育 | 备案信息：<a target="_blank" style="color: #b22222;text-decoration: none;"  href="https://beian.miit.gov.cn/">京ICP备2024046812号-4</a>
            </div>
        </div>
        <div class="footer-bottom-bar"></div>
    </div>
</template>


<script>
export default {
    name: "homeFooter",
    props: {},
    data() {
        return {}
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {}
};
</script>

<style scoped lang="scss">
.home-footer-container{
    width: 100%;
    min-height: 182px;
    border-top: 1.5px solid #b22222;
    padding: 10px 0 0 0;
    box-sizing: border-box;
}
.footer-bottom-bar{
    width: 100%;
    height: 5px;
    background-color: #b22222;
}
.slogan1-container{
    width: 100%;
    min-height: 30px;
    line-height: 24px;
    font-size: 16px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 3px;
    text-align: center;
    padding-top: 10px;
    box-sizing: border-box;
}
.slogan2-container{
    width: 100%;
    min-height: 34px;
    line-height: 34px;
    color: #333;
    font-weight: bold;
    text-align: center;
    font-size: 15px;
}
.slogan3-container{
    width: 100%;
    min-height: 24px;
    line-height: 24px;
    font-family: sans-serif;
    text-align: center;
    font-size: 15px;
    font-style: italic;
    color: #6b7280;
}
.slogan4-container{
    width: 100%;
    min-height: 24px;
    line-height: 24px;
    font-size: 15px;
    color: #d4af37;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 2px;
    text-align: center;
    margin-bottom: 11px;
}
.slogan5-container{
    width: 100%;
    min-height: 50px;
    border-top: 1px solid #e5e7eb;
    padding: 5px 0 0 0;
    box-sizing: border-box;
}
.slogan6-container{
    width: 100%;
    min-height: 20px;
    text-align: center;
    font-size: 13px;
    color: #9ca3af;
    line-height: 20px;
    font-family: sans-serif;
}
@media (max-width: 1024px) {
    .slogan1-container { font-size: 14px; letter-spacing: 1px; }
    .slogan2-container { font-size: 13px; }
    .slogan3-container, .slogan4-container { font-size: 12px; }
}
</style>